import React from 'react';
import {List, Dropdown, Icon, Menu, Spin} from 'antd';
import LinkComponent from '../../../LinkComponent/LinkComponent';
import Img from 'react-image';

const FeedChannelItem = ({
  item,
  pathFrom,
  handleDeleteChannel,
  description,
  eventsNumber,
  subscribersNumber,
  pageType
 }) => {
  const menu = (
    <Menu>
      <Menu.Item>
        <LinkComponent
          pathTo={`/Admin_configuration/${item.id}`}
          pathFrom={pathFrom}
        >
          <span>Edit</span>
        </LinkComponent>
      </Menu.Item>
      <Menu.Item>
        <span onClick={(event) => handleDeleteChannel(event, item)}>Delete</span>
      </Menu.Item>
    </Menu>
  );

  const loader = <Spin className="preloader" />;

  return (
    <List.Item className="list-item-horizontal">
      <LinkComponent
        isShow
        className="channel"
        pathTo={`/Channels/${item.id}`}
        pathFrom={pathFrom}
      >
        <div className="list-item-horizontal-image list-item__image-container">
          <Img
            src={item.thumbnail || ''}
            loader={loader}
          />
        </div>
        <div className="list-item-horizontal-content">
          <div className="list-item-title">{item.title}</div>
          <div className="list-item-text" title={item.description}>{description || ''}</div>
          <div className="list-item-meta">
            <div className="list-item-events">
              <span className="link">{eventsNumber || '0'} Events</span>
            </div>
            <div className="list-item-subscribers">{subscribersNumber.toString() || '0'} subscribers</div>
            {
              pageType === 'myProfile' && (
                <div className="myProfile__dropdown-menu">
                  <Dropdown overlay={menu}>
                    <div>
                      <a className="ant-dropdown-link" href="">
                        <Icon type="ellipsis" style={{fontSize:'26px'}} />
                      </a>
                    </div>
                  </Dropdown>
                </div>
              )
            }
          </div>
        </div>
      </LinkComponent>
    </List.Item>
  )
};

export default FeedChannelItem;



// WEBPACK FOOTER //
// ./src/components/Modules/ChannelList/FeedChannelItem/index.js